module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bd90e72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/dropdown-menu.vue
// module id = 342
// module chunks = 0